const METERS_PER_KM = 1000;

export const mapFilteredVendorToListItem = <T extends object>(item: T): T => {
	if (!("distance" in item)) {
		return item;
	}
	const distance = item.distance;
	if (typeof distance !== "number" || !Number.isFinite(distance)) {
		return item;
	}
	return {
		...item,
		distance: distance / METERS_PER_KM,
	};
};
